var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 91 91",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 91 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.9 24.8c-5.7-.5-11.6 0-17.2 1.2-3.1.6-2.2 5.1.7 5.2 5.5.4 11 .6 16.5.7 4.6 0 4.5-6.7 0-7.1zM33.5 24.2c-5.7-.5-11.6 0-17.2 1.2-3.1.6-2.2 5.1.7 5.2 5.5.4 11 .6 16.5.7 4.6 0 4.4-6.7 0-7.1zM62.9 48.9c-1.3 1.1-1.4 2-1.8 3.5-.3 1.5-1.1 2.8-1.9 4.1-1.7 2.7-3.9 5.1-6.6 6.9-5.3 3.5-11.7 4.1-17.8 5.1-.8.1-.8 1.3-.2 1.7C41.3 74 49.8 72 55.9 68c3.1-2 5.8-4.7 8-7.7 1.8-2.6 4.9-6.9 3.8-10.1-.7-2.2-3.1-2.7-4.8-1.3z",
    fill: "#ff771b",
    className: "fill-4e7a9e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.854707d0b63ccb4dbf887fc395d41864.svg";
export { ForwardRef as ReactComponent };